module.exports = __webpack_public_path__ + "img/Free-Hair-Curl.b3e8d362.jpg";